import axios from 'axios';

const API_URL = process.env.VUE_APP_API_BASE_URL + 'codes/';

class CodeListService {

  getDeleteReasons() {
    var full_api_url = API_URL + 'delete_reasons';

    return axios
      .get(full_api_url, { headers: { access_token: process.env.VUE_APP_API_KEY } })
      .then(response => {
        return response.data;
      });
  }

}



export default new CodeListService();
